/** localStorage key：开启后 Wasabi 展示 URL 会被故意破坏，用于验证 S3 fallback */
export const DEBUG_WASABI_FAIL_KEY = 'digen-debug-wasabi-fail'

const WASABI_HOST_PATTERN = /wasabisys\.com/i

export function isWasabiFailDebugEnabled(): boolean {
  if (process.env.NODE_ENV !== 'development') return false
  if (typeof localStorage === 'undefined') return false
  return localStorage.getItem(DEBUG_WASABI_FAIL_KEY) === '1'
}

/** 调试：破坏 Wasabi URL，使首次加载必定失败 */
export function breakWasabiUrlForDebug(url: string): string {
  if (!isWasabiFailDebugEnabled() || !WASABI_HOST_PATTERN.test(url)) {
    return url
  }

  const broken = url.includes('?')
    ? url.replace('?', '/__debug_wasabi_fail__?')
    : `${url}/__debug_wasabi_fail__`

  console.warn('[image-cache:debug] Wasabi URL 已故意破坏，用于测试 S3 fallback:', broken)
  return broken
}
